import {useShopperOrdersMutation} from '@salesforce/commerce-sdk-react'
import {PaymentInstrumentModel} from '_types'
import {useLoader} from '_context'

const useOrder = (shouldShowLoader: boolean = true) => {
    const {mutateAsync: createOrderMutation} = useShopperOrdersMutation('createOrder')
    const {mutateAsync: createPaymentInstrumentMutation} = useShopperOrdersMutation('createPaymentInstrumentForOrder')
    const {mutateAsync: updatePaymentInstrumentMutation} = useShopperOrdersMutation('updatePaymentInstrumentForOrder')

    const {showLoader, hideLoader} = useLoader()

    const createOrder = async (basketId?: string) => {
        if (basketId) {
            if (showLoader) showLoader()

            try {
                const order = await createOrderMutation({
                    body: {basketId: basketId},
                })
                return order
            } finally {
                if (shouldShowLoader) hideLoader()
            }
        }
    }

    const createPaymentInstrument = async (orderNo: string, paymentInstrument: PaymentInstrumentModel) => {
        if (shouldShowLoader) showLoader()
        try {
            const order = await createPaymentInstrumentMutation({
                parameters: {orderNo},
                body: paymentInstrument,
            })
            return order
        } finally {
            if (shouldShowLoader) hideLoader()
        }
    }

    const updatePaymentInstrument = async (orderNo: string, paymentInstrumentId: string, paymentInstrument: PaymentInstrumentModel) => {
        if (shouldShowLoader) showLoader()
        try {
            const order = await updatePaymentInstrumentMutation({
                parameters: {orderNo, paymentInstrumentId},
                body: paymentInstrument,
            })
            return order
        } finally {
            if (shouldShowLoader) hideLoader()
        }
    }

    return {
        createOrder,
        createPaymentInstrument,
        updatePaymentInstrument,
    }
}

export {useOrder}
